import type {
    AuthDataResponse,
    BasicResponse,
    DataResponse,
} from "@/types/auth-type";
import { api } from "./api";
import { handleAxiosError } from "./handleAxiosError";
import type { AddressType, SearchAreaType } from "@/types/user-type";
import type { AddressFormData } from "@/schemas/user-schema";

export const getDataUser = async (): Promise<AuthDataResponse> => {
    try {
        const response = await api.get("/user/data");
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const addAddressRequest = async (
    data: AddressFormData,
): Promise<DataResponse<AddressType>> => {
    try {
        const response = await api.post("/user/address", data);
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const updateAddressRequest = async ({
    id,
    data,
}: {
    id: number;
    data: AddressFormData;
}): Promise<DataResponse<AddressType>> => {
    try {
        const response = await api.put(`/user/address/${id}`, data);
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const deleteAddressRequest = async (
    id: number,
): Promise<BasicResponse> => {
    try {
        const response = await api.delete(`/user/address/${id}`);
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const setMainAddressRequest = async (
    id: number,
): Promise<BasicResponse> => {
    try {
        const response = await api.put(`/user/address/${id}/main`);
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const searchBiteshipAreaRequest = async (
    keyword: string,
): Promise<DataResponse<SearchAreaType[]>> => {
    try {
        const response = await api.get(`/biteship/search-area`, {
            params: { keyword },
        });
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};
